import directives from './module';
import {HttpSvcFactory} from '../services/HttpSvc';

directives.directive('validateUsername', ($filter: ng.IFilterService,
                                          $q: ng.IQService,
                                          HttpSvc: HttpSvcFactory) => {
    return {
        require: 'ngModel',
        link(scope: any, element: any, attrs: any, ctrl: ng.INgModelController) {
            const usernameAvailChecker = (username: string) =>
                HttpSvc<ApiError>($filter('encodeUsername')(username) + '/profile')
                    .get().then(response => response.data.errorCode === 404);

            ctrl.$asyncValidators['validateUsername'] = viewValue => ((() => {
                if (viewValue && viewValue.length > 0 && viewValue !== options.user.username) {
                    return usernameAvailChecker(viewValue);
                } else {
                    return $q.resolve(true);
                }
            })()).then(r => r ? $q.resolve() : $q.reject());
        }
    };
});

directives.directive('validateEmail', ($q: ng.IQService,
                                       HttpSvc: HttpSvcFactory) => {
    const apiSvc = HttpSvc<ApiError>('profile', 'check-email');
    return {
        require: 'ngModel',
        link(scope: any, element: any, attrs: any, ctrl: ng.INgModelController) {
            const emailAvailChecker = (email: string) =>
                apiSvc.chain(email).get()
                    .then(response => response.data.errorCode === 404)
                    .catch(() => true);

            ctrl.$asyncValidators['validateEmail'] = viewValue => $q((resolve: ng.IQResolveReject<void>, reject: ng.IQResolveReject<any>) => {
                if (viewValue && viewValue.length > 0 && viewValue !== options.user.email) {
                    emailAvailChecker(viewValue).then(r => r ? resolve() : reject());
                } else {
                    resolve();
                }
            });
        }
    };
});

directives.directive('match', [function () {
    return {
        require: 'ngModel',
        scope: {
            match: '='
        },
        link: function (scope: any, elem: any, attrs: any, ctrl: ng.INgModelController) {
            scope.$watch('match', function () {
                ctrl.$validate();
            });
            ctrl.$validators['match'] = function (modelValue) {
                return (scope.match === undefined || ctrl.$pristine && (angular.isUndefined(modelValue) || modelValue === '')) || modelValue === scope.match;
            };
        }
    };
}]);

directives.directive('resetField', [function () {
    return {
        require: 'ngModel',
        link: function (scope: any, elem: any, attrs: any, ctrl: ng.INgModelController) {
            ctrl.$parsers.unshift(function (viewValue) {
                ctrl.$setValidity(attrs.resetField, true);
                return viewValue;
            });
        }
    };
}]);






// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/validatorDirectives.ts